import { useAppSelector } from "@grassrootly/rn-core";
import { ICompetitionView, ISeason, IPlayerSeasonStats, IGameView } from "@grassrootly/api";

export const useCompetitions = (): ICompetitionView[] => {
  return useAppSelector((state) => state.competitions.competitions);
};

export const useCompetition = (competitionId: number): ICompetitionView | null => {
  return useAppSelector((state) => 
    state.competitions.competitions.find((c: ICompetitionView) => c.id === competitionId) || null
  );
};

export const useCompetitionSeasons = (competitionId: number): ISeason[] => {
  return useAppSelector((state) => state.competitions.seasons[competitionId] || []);
};

export const useDefaultSeasonId = (competitionId: number): number | null => {
  return useAppSelector((state) => state.competitions.defaultSeasonIds[competitionId] || null);
};

export const useSeasonStats = (seasonId: number): IPlayerSeasonStats[] => {
  return useAppSelector((state) => state.competitions.seasonStats[seasonId] || []);
};

export const useSeasonMatches = (seasonId: number): IGameView[] => {
  return useAppSelector((state) => state.competitions.seasonMatches[seasonId] || []);
};
